'use memo';

import type { ComponentPropsWithoutRef, ReactNode } from 'react';
import { forwardRef } from 'react';

import { PopoverContent } from '@/components/ui/popover';
import { cn } from '@/lib/cn';

/**
 * Combobox（cmdk ベース）用の PopoverContent ラッパー。
 * ビューポート内に収め、検索行＋リストのスクロールをリスト側に集約する。
 *
 * @see FilterChipPopoverContent — 同じ Radix available-height + cmdk flex 契約
 */
export const ComboboxPopoverContent = forwardRef<
  HTMLDivElement,
  Omit<ComponentPropsWithoutRef<typeof PopoverContent>, 'children'> & {
    children: ReactNode;
  }
>(({ children, className, ...props }, ref) => {
  return (
    <PopoverContent
      ref={ref}
      className={cn(
        'p-0',
        'max-h-(--radix-popover-content-available-height)',
        'flex flex-col overflow-hidden',
        className,
      )}
      collisionPadding={16}
      {...props}
    >
      <div
        className={cn(
          'flex min-h-0 flex-1 flex-col overflow-hidden',
          '[&_[cmdk-root]]:flex-1 [&_[cmdk-root]]:h-auto [&_[cmdk-root]]:min-h-0',
          '[&_[cmdk-list]]:max-h-none [&_[cmdk-list]]:flex-1 [&_[cmdk-list]]:min-h-0',
        )}
      >
        {children}
      </div>
    </PopoverContent>
  );
});

ComboboxPopoverContent.displayName = 'ComboboxPopoverContent';
